<template>
  <div ref="detailAuthor" class="content-author">
    <div class="top">
      <div class="avatar-box" @click="handleClickAvatar">
        <img class="avatar" :src="detail.user.avatar || ''" />
      </div>
      <div class="desc">
        <div class="nick-box">
          <div class="nick" @click="handleClickAvatar">{{ detail.user.username || "" }}</div>
          <!-- <div class="tag">版主大神</div> -->
          <UserTagGroup :user="detail.user" />
        </div>
        <div class="update">{{ formatDuration(detail.user.content_at) }}更新</div>
      </div>
      <!-- 内容作者与登录用户不同才显示关注 -->
      <div
        v-if="loginUid !== detail.user.uid"
        class="look"
        :class="{ looked: detail.user.is_followed }"
        @click="onFollow"
      >
        {{ detail.user.is_followed ? "已关注" : "关注" }}
      </div>
    </div>
    <div class="center">
      <div class="enum">
        <span class="label">原创</span>
        <span class="value">{{ formatCount(detail.user.content_num) }}</span>
      </div>
      <div class="enum">
        <span class="label">获阅数量</span>
        <span class="value">{{ formatCount(detail.user.read_num) }}</span>
      </div>
      <div class="enum">
        <span class="label">获赞</span>
        <span class="value">{{ formatCount(detail.user.like_num) }}</span>
      </div>
    </div>
    <div class="bottom">
      <DetailContributor :detail="detail" style="width: 100%; justify-content: space-between" />
    </div>
  </div>
</template>
<script>
import dayjs from "@/plugins/dayjs";
import { mapGetters } from "vuex";
import { apiUserAddFollow } from "@/api/userApi";
import UserTagGroup from "@/components/UserTag/UserTagGroup";
import DetailContributor from "./detailContributor";

export default {
  name: "DetailAuthor",
  components: {
    UserTagGroup,
    DetailContributor
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      avatarList: []
    };
  },
  computed: {
    ...mapGetters(["loginUid"])
  },
  mounted() {
    this.$refs.detailAuthor.parentElement.style.padding = "0";
  },
  methods: {
    // 关注用户
    onFollow() {
      if (!this.isLoginShow()) return false;
      let params = {
        follow_uid: this.detail.user.uid
      };
      apiUserAddFollow(params).then(res => {
        this.detail.user.is_followed = this.detail.user.is_followed ? 0 : 1;
        this.detail.user.is_followed ? this.detail.user.follow_num++ : this.detail.user.follow_num--;
        this.$emit("refresh", this.detail, this.user);
      });
    },
    handleClickAvatar() {
      this.$router.push(`/user/index/${this.detail.user.uid}.html`);
    },
    formatDuration(time) {
      if (time < 60) return "刚刚";
      const duration = dayjs.duration(time, "seconds");
      if (time < 60 * 60) return `${duration.format("m分钟前")}`;
      if (time < 60 * 60 * 24) return `${duration.format("H小时前")}`;
      if (time < 60 * 60 * 24 * 7) return `${duration.format("D天前")}`;
      return `${dayjs(Date.now() - time * 1000).format("YYYY年M月D日")}`;
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content-author {
  background-color: #fff;
  border-radius: 8px;
  width: 328px;
  .top,
  .center,
  .bottom {
    padding: 0 14px;
  }
  .top {
    padding-top: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    .avatar-box {
      cursor: pointer;
      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 20px;
      }
    }
    .desc {
      width: 0;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .nick-box {
        display: flex;
        gap: 3px;
        align-items: center;
        .nick {
          cursor: pointer;
          width: fit-content;
          max-width: 100px;
          color: #273443;
          font-size: 14px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tag {
          background-color: #ffdea3;
          border-radius: 2px;
          font-size: 10px;
          text-align: center;
          line-height: 16px;
          padding: 0 4px;
          color: #82675c;
          margin-left: 3px;
        }
      }
      .update {
        color: #999999;
        font-size: 12px;
      }
    }
    .look {
      width: 60px;
      line-height: 28px;
      background-color: #00afe8;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      text-align: center;
      &.looked {
        background-color: #ccc;
      }
    }
  }
  .center {
    padding-top: 23px;
    padding-bottom: 11px;
    display: flex;
    justify-content: space-between;
    .enum {
      .value {
        margin-left: 2px;
        color: #273443;
        font-size: 14px;
        font-weight: bold;
      }
      .label {
        color: #999999;
        font-size: 12px;
      }
    }
  }
  .bottom {
    display: flex;
    border-top: 1px solid #f0f0f0;
    padding-top: 9px;
    padding-bottom: 11px;
  }
}
</style>
